import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Puzzles from "./pages/Puzzles";
import TestElo from "./pages/TestElo";
import Analyze from "./pages/Analyze";
import AnalysisView from "./pages/AnalysisView";
import Traps from "./pages/Traps";
import TrapView from "./pages/TrapView";
import AuthCallback from "./pages/AuthCallback";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-12 text-center text-[#A8A196]">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  // Detect Emergent Google OAuth return (session_id in URL fragment) synchronously
  // during render — running this in useEffect would let ProtectedRoute redirect first.
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return (
      <>
        <Nav />
        <AuthCallback />
      </>
    );
  }
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/traps" element={<Traps />} />
        <Route path="/traps/:trapId" element={<TrapView />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/puzzles" element={<Protected><Puzzles /></Protected>} />
        <Route path="/test-elo" element={<Protected><TestElo /></Protected>} />
        <Route path="/analyze" element={<Protected><Analyze /></Protected>} />
        <Route path="/analyze/:id" element={<Protected><AnalysisView /></Protected>} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster theme="dark" position="top-center" toastOptions={{
            style: { background: "#1C1914", color: "#EFE8D8", border: "1px solid rgba(239,232,216,0.1)", fontFamily: "Inter" },
          }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
